<xea-popover-base
  [popoverText]="popoverText"
  [cellClass]="headerClass"
  [position]="position"
  [alwaysShowPopover]="alwaysShowPopover"
  [popoverParentNode]="popoverParentNode"
  [params]="params"
>
  @if (iconClass) {
    <i [ngClass]="iconClass"></i>
  }
  <span>{{ params.displayName }}</span>
</xea-popover-base>
